"use strict";

export default class CourseSearch {
    constructor(url) {
        this.url = url;
        this.searchTimeout = 0;
        this.init();
    }

    init() {
        let _this = this;

        $("#search-clear-button").on("click", function() {
            $("#search-box").val("").focus();
            _this.clearSearchResults();
            $(this).addClass("invisible");
        });

        $("#search-box").on("input propertychange paste", function() {
            _this.clearSearchResults();

            $("#search-clear-button").removeClass("invisible");

            let text = $(this).val();
            if (text.length < 2) {
                if (text.length == 0) {
                    $("#search-clear-button").addClass("invisible");
                }
                return;
            }

            if (_this.searchTimeout) {
                window.clearTimeout(_this.searchTimeout);
                _this.searchTimeout = 0;
            }

            _this.searchTimeout = window.setTimeout(function() {
                $.ajax({
                    url: _this.url,
                    data: {
                        search: text
                    },
                    success: function(data) {
                        _this.clearSearchResults();

                        let numberOfResults = data.results.length;
                        if (numberOfResults == 0) {
                            $("#search-result-template").removeClass("d-none");
                        }

                        for (let i = 0; i < numberOfResults; i++) {
                            let course = data.results[i];
                            let row = $("#search-result-template").clone().removeAttr("id").removeClass("d-none");
                            row.find("a").attr("href", course.url);
                            row.find(".name").text(course.title);
                            row.find(".short-description").text(course.subtitle);

                            if (course.is_online) {
                                row.find(".course-type.online").removeClass("d-none");
                            }
                            if (course.is_classroom) {
                                row.find(".course-type.classroom").removeClass("d-none");
                            }
                            if (course.is_recurrent) {
                                row.find(".course-type.recurrent").removeClass("d-none");
                            }

                            $("#search-results").append(row);
                        }
                    },
                    error: function() {

                    }
                });
            }, 250);
        });
    }

    clearSearchResults() {
        $("#search-results").find("li").each(function() {
            if ($(this).attr("id") == "search-result-template") {
                $(this).addClass("d-none");
            } else {
                $(this).remove();
            }
        });
    }
}
